import { WithStyles, withStyles } from '@mui/styles';
import { UserValidationRecord } from '@tassat/fred-definitions';

import PendingClientValidationStatusModal from './pendingClientValidationStatusModal';
import { muiStyles } from './styles';

export interface PendingClientValidationStatusModalProps extends WithStyles<typeof muiStyles> {
    data: Partial<UserValidationRecord> & {
        firmName: string;
    };
    hadleOnClick: () => void;
}

export default withStyles(muiStyles)(PendingClientValidationStatusModal);